
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TCaseRow, API_TCaseCategoryPrevious } from "@/models/case_profiles";
import { TStep } from "@/models/questionnaire";
import { SMQuestionnaire } from "@/store";
import ProfileTemplateRow from "@/modules/Compliance/Profile/ProfileTemplateRow.vue";

@Component({
  components: { ProfileTemplateRow },
})
export default class ProfileTemplate extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: Array }) readonly rows!: API_TCaseRow[];
  @Prop({ type: Boolean, default: false }) readonly isHistory!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hasHistory!: boolean;
  @Prop({ type: Number, required: true }) readonly categoryId!: number;
  @Prop({ type: Boolean, default: false }) readonly isEditable!: boolean;

  previousCategories: API_TCaseCategoryPrevious = {};

  isPreviousShown = false;

  get hasData() {
    return !!this.$slots["default"];
  }

  get lastUpdatedStep() {
    return SMQuestionnaire.lastUpdatedStep;
  }

  isLastRow(index: number) {
    return index === this.rows.length - 1;
  }

  previousCategoryTitle(index: string) {
    return `Previous ${this.title.toLowerCase()} ${Number(index) + 1}`;
  }

  @Watch("lastUpdatedStep", { deep: true })
  lastUpdatedStepChanged(val: TStep) {
    const row = this.rows.find((row) => row.step.ID === val.ID);

    if (row) row.step = val;
  }

  isEditEnable(skipStep: boolean) {
    return this.isEditable && !skipStep;
  }

  emitEdit(stepId: number, isHistory: boolean, categoryId: number) {
    this.$emit("edit", { stepId, isHistory, categoryId });
  }

  async viewPrevious() {
    this.isPreviousShown = !this.isPreviousShown;

    if (!this.isPreviousShown) return;

    await this.getHistoricalData();
  }

  async getHistoricalData() {
    if (!this.categoryId) return;

    const { data } = await this.axios.get(
      API_ROUTES.COMPLIANCE_CATEGORY_HISTORICAL(this.categoryId)
    );

    if (!data) return;

    this.previousCategories = data;
  }
}
